export const DISCOUNT_CAMPAIGNS_DETAIL_SUCCESS = "DISCOUNT_CAMPAIGNS_DETAIL_SUCCESS";
export const DISCOUNT_CAMPAIGNS_DETAIL_ERROR = "DISCOUNT_CAMPAIGNS_DETAIL_ERROR";
export const DISCOUNT_CAMPAIGNS_DETAIL_START = "DISCOUNT_CAMPAIGNS_DETAIL_START";

export const DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_SUCCESS = "DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_SUCCESS";
export const DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_ERROR = "DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_ERROR";
export const DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_START = "DISCOUNT_SHADULE_CAMPAIGNS_DETAIL_START";

export const DISCOUNT_SHADULE_CAMPAIGNS_LIVE_FILTER_SUCCESS = "DISCOUNT_SHADULE_CAMPAIGNS_LIVE_FILTER_SUCCESS";
export const DISCOUNT_SHADULE_CAMPAIGNS_SHADULE_FILTER_SUCCESS = "DISCOUNT_SHADULE_CAMPAIGNS_SHADULE_FILTER_SUCCESS";
export const DISCOUNT_COMPAIGNS_MODEL_FILTER = "DISCOUNT_COMPAIGNS_MODEL_FILTER";

export const DISCOUNT_CAMPAIGNS_ALL_FILTER_SUCCESS = "DISCOUNT_CAMPAIGNS_ALL_FILTER_SUCCESS";

export const DISCOUNT_ALL_CAMPAIGNS_DETAIL_SUCCESS = "DISCOUNT_ALL_CAMPAIGNS_DETAIL_SUCCESS";
export const DISCOUNT_ALL_CAMPAIGNS_DETAIL_ERROR = "DISCOUNT_ALL_CAMPAIGNS_DETAIL_ERROR";
export const DISCOUNT_ALL_CAMPAIGNS_DETAIL_START = "DISCOUNT_ALL_CAMPAIGNS_DETAIL_START";

